import { withStyles, ListItemSecondaryAction } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import SettingsDrawer from '../../components/App/Drawers/settingsDrawer';
import PageContentWrapper from '../../components/App/PageComponents/pageContentWrapper';
import AppContent from '../../components/App/appContent';
import HelpButtonTooltip from '../../components/Common/HelpButton/HelpButtonTooltip';
import UserAvatar from '../../components/Common/UserAvatar';
import Spinner from '../../components/Common/spinner';
import withErrorCatcher from '../../components/Common/withErrorCatcher.js';
import UserEditModal from './userEditModal';

const UserSettingsItem = withTranslation('userSettings')((props) => {
    const { primary, secondary, withoutDivider, t } = props

    return (
        <Fragment>
            <ListItem>

                <ListItemText
                    primary={primary}
                    secondary={t(secondary)} />
            </ListItem>

            {withoutDivider ? null : <Divider />}
        </Fragment>
    )
})
// Apply some reset
const styles = theme => ({
    paper: {
        padding: 16
    },
    paperStyle: {
        minHeight: 500,
        position: 'relative',
        marginBottom: 40
    },
    spinnerProgress: {
        position: 'absolute'
    },
    listStyle: {
        paddingTop: 0,
        paddingBottom: 0
    },
    switchStyle: {
        marginBottom: 16
    },
    submitStyle: {
        marginTop: 32
    },
    userTitle: {
        fontSize: '18px',
        fontWeight: '100'
    },
    useSettingsTitle: {
        fontSize: '36px',
        fontWeight: '100'
    },
    textFiledStyle: {
        fontWeight: '100'
    },
    avatar: {
        width: 80,
        height: 80,
        border: '1px solid #dbdbdb'
    },
    row: {
        display: 'flex',
        justifyContent: 'center'
    },
    listLabel: {
        marginBottom: 10
    },
    button: {
        margin: theme.spacing.unit,
    },
    titleContainer: {
        marginBottom: 16
    },
    title: {
        "fontFamily": "Rubik",
        "fontSize": "20px",
        "fontWeight": "500",
        "fontStretch": "normal",
        "fontStyle": "normal",
        "lineHeight": "normal",
        "letterSpacing": "0.25px",
    }
});

class UserSettings extends Component {

    state = {
        loaded: false
    };
    lang = () => {
        const { lang } = this.props.userData.profileData

        switch (lang) {
            case 'en-US':
                return 'English'
            case 'he-IL':
                return 'עברית'
            case 'es-AR':
                return 'Español'
            case 'ru':
                return 'русский'
            case 'pt-BR':
                return 'Português'
            case 'de':
                return 'Deutsch'
            case 'pl':
                return 'Polski'
            case 'uk-UA': 
                return 'Українська'
            // unusupported now
            case 'it':
                return 'italian'
            case 'ar':
                return 'Arabic'
            default:
                return 'English'
                break;
        }
    }

    componentDidMount() {
        this.initUserData()
    }
    // dialog
    initUserData = () => {
        const { userSettingsService } = this.props

        this.setState({ loaded: false })
        userSettingsService.getUserFullData().then(userData => {
            this.setState({
                userData,
                loaded: true,
            })
        })
    };

    getLink = () => {
        const lang = this.state.userData?.lang === 'he-IL' ? 'he' : 'en'

        return `https://help.tuqqi.com/${lang}/articles/5387236-setting-up-your-user-profile`
    }

    content() {
        const { userData, classes, t } = this.props;

        const { loaded } = this.state

        if (!loaded) {
            return <Spinner classes={{ progress: classes.spinnerProgress }} />
        }
        const { orgUid } = userData.profileData.org
        const { firstname, lastname, tag, profileImageUrl, isFeedPersonalized, title, level,
            email, lastModification, creationDateTime, lang, suggestedNews, auth0_id, subscribedTagsDtos: subscribedTags, bio, birthday, phone,
            nickname, certificationDtos, officeAddress, homeAddress, startWorkingDate, endWorkingDate, employeeId
        } = this.state.userData

        return (
            <Fragment>
                <List className={classes.listStyle}>
                    <ListItem >
                        <UserAvatar userUUID={auth0_id} withShadow={true} />
                        <ListItemText
                            primary={firstname + ' ' + lastname}
                            secondary={'@' + tag} />
                        <ListItemSecondaryAction>
                            <div data-intrcm-id="userSettings_h9rn788j" style={{ padding: '16px' }}>
                                <UserEditModal user={this.state.userData} handleClose={this.initUserData} />
                            </div>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <UserSettingsItem primary={firstname + ' ' + lastname} secondary='Name' />


                    <UserSettingsItem primary={title} secondary='Title' />
                    <UserSettingsItem primary={'@' + tag} secondary='User Name' />
                    <UserSettingsItem primary={subscribedTags.map(tag => `#${tag.tag} `)} secondary='Subscribed Channels' />
                    <UserSettingsItem primary={email} secondary='Email' />
                    <UserSettingsItem primary={this.lang()} secondary='Language' />
                    <UserSettingsItem primary={orgUid} secondary='Organization ID' />
                    <UserSettingsItem primary={suggestedNews} secondary='Suggested News' />
                    <UserSettingsItem primary={moment(lastModification).format('MMMM Do YYYY, H:mm')} secondary='Last Update' />
                    <UserSettingsItem primary={moment(creationDateTime).format('MMMM Do YYYY, H:mm')} secondary='Created on' />
                    <UserSettingsItem primary={bio} secondary='Bio' />
                    <UserSettingsItem primary={moment(birthday).format('MMMM Do YYYY')} secondary='Birthday' />
                    <UserSettingsItem primary={phone} secondary='Phone Number' />
                    <UserSettingsItem primary={homeAddress} secondary='Home address' />
                    <UserSettingsItem primary={officeAddress} secondary='Office address' />
                    <UserSettingsItem primary={nickname} secondary='Nickname' />
                    <UserSettingsItem primary={moment(startWorkingDate).format('MMMM Do YYYY')} secondary='Start working date' />
                    <UserSettingsItem primary={moment(endWorkingDate).format('MMMM Do YYYY')} secondary='End working date' />
                    <UserSettingsItem primary={employeeId} secondary='Employee id' />
                    <UserSettingsItem primary={certificationDtos.map(c => c.title).join(', ')} secondary='Certifications' />

                </List>
                <div data-intrcm-id="userSettings_2sr6yid6" style={{ padding: '16px' }}>
                    <UserEditModal user={this.state.userData} handleClose={this.initUserData} />
                </div>
            </Fragment>

        )
    }
    render() {
        const { classes, t } = this.props;

        return (
            <AppContent >
                <PageContentWrapper drawer={<SettingsDrawer selected="user" />}>
                    <Grid spacing={16}>
                        <HelpButtonTooltip customLink={this.getLink()} link='' classes={{ container: classes.titleContainer }}>
                            <span className={classes.title}>
                                {t('User settings')}
                            </span>
                        </HelpButtonTooltip>
                        <Paper className={classes.paperStyle}>
                            {this.content()}
                        </Paper>
                    </Grid>
                </PageContentWrapper>
            </AppContent>)
    }

}

const mapStateToProps = (state) => ({
    userData: state.userData,
    ...state.services
})

const mapDispatchToProps = dispatch => {
    return { dispatch: dispatch }
}

export default compose(withStyles(styles), withTranslation('userSettings'), withErrorCatcher(),
    connect(mapStateToProps, mapDispatchToProps))(UserSettings);
